import loadable from '@loadable/component';
import React, { useState } from 'react';
import { EventMapScopedProps } from '../../../types';
import type { Event } from '../../../types/index';
import { DEFAULT_ZOOM } from '../../_shared/constants';
import type { DateAndTimeProps } from './DateAndTime/DateAndTime';
import { DateAndTime } from './DateAndTime/DateAndTime';
import type { LocationProps } from './Location/Location';
import { Location } from './Location/Location';

type WhenAndWhereProps = {
    dates: DateAndTimeProps;
    location: LocationProps;
    map: Omit<EventMapScopedProps, 'venueName' | 'venueAddress'>;
} & Pick<Event, 'isSeriesParent'>;

export const WhenAndWhere = ({
    dates,
    location,
    map,
    isSeriesParent,
}: WhenAndWhereProps) => {
    const { shouldDisplayMap, location: mapLocation, gMapsApiKey } = map;
    const [isMapExpanded, setIsMapExpanded] = useState(false);
    let lazyMap = null;

    if (isMapExpanded) {
        const Map = loadable(() => import('./Map/Map').then(({ Map }) => Map));
        lazyMap = (
            <Map
                location={mapLocation}
                gMapsApiKey={gMapsApiKey}
                mapZoom={DEFAULT_ZOOM}
            />
        );
    }

    return (
        <>
            <DateAndTime
                {...{
                    ...dates,
                    isSeriesParent,
                }}
            />

            <Location
                {...{
                    ...location,
                    onToggleButtonMap: setIsMapExpanded,
                    isMapExpanded: isMapExpanded,
                }}
            />
            {shouldDisplayMap && lazyMap}
        </>
    );
};
